import React from 'react';
import { ErrorPage } from '../containers/ErrorPage';
const Custom404 = () => <ErrorPage statusCode={404} message="We can't sniff out the page you're looking for." data-sentry-element="ErrorPage" data-sentry-component="Custom404" data-sentry-source-file="404.tsx" />;
export default Custom404;